.content {
  width: 100%;
}
